module.exports = __webpack_public_path__ + "static/tsb-living-80d2ddf79f82f56ee6f5e06dc92a4cdd.png";